// extracted by mini-css-extract-plugin
export default {"Orders":"Orders_Orders__NAgbX","OrdersFrame":"Orders_OrdersFrame__ZORkY","OrdersMobile":"Orders_OrdersMobile__z7-KY"};